import React from "react";
import { connect } from "react-redux";
import ReactIframeResizer from "../../common/iFrameResizerComponent";
import * as d from "../../../reducers/domainReducer";
import { withRouter } from 'react-router';
import { logUI } from '../../../api/andyliticsApi';
import { getURLPath } from '../../../helpers/Tools';
import { getFirstName } from "../../../helpers/formatting";
import Spinner from "../../common/spinner";

const SURVEY_COMPLETED_GOBACKTODASHBOARD = "surveycompleted-dashboard";
const SURVEY_COMPLETED_SCHEDULEEVISIT = "surveycompleted-scheduleevisit";
const SURVEY_COMPLETED_SCHEDULEVIDEOVISIT = "surveycompleted-schedulevideovisit";
const SURVEY_COMPLETED_FINDTESTINGLOCATION = "surveycompleted-findtestinglocation";

class Covid19ScreenerSurvey extends React.Component {
    constructor(props) {
        super(props);
        this.processWindowMessage = this.processWindowMessage.bind(this);
        this.onSurveyLoaded = this.onSurveyLoaded.bind(this);
        this.surveyUrl = null;
        this.isIframeInitialLoaded = false;
    }

    componentDidMount() {
        window.addEventListener("message", this.processWindowMessage);
        this.isIframeInitialLoaded = false;
        const { surveyBaseUrl } = this.props;
        let andyliticsJson = {
            surveyBaseUrl
        };
        logUI("MBHWeb.UI.Covid19ScreenerSurvey.ComponentDidMount", new Date(), getURLPath(), andyliticsJson);
    }

    onSurveyLoaded(event) {
        if (!this.isIframeInitialLoaded) {
            logUI("MBHWeb.UI.Covid19ScreenerSurvey.Loaded", new Date(), getURLPath(), { surveyUrl: this.surveyUrl });
            this.isIframeInitialLoaded = true;
        }
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.processWindowMessage);
    }

    processWindowMessage(messageEvent) {
        const { currentUser, serverData } = this.props;
        if (messageEvent) {
            const eventData = messageEvent.data && typeof messageEvent.data === 'string' ? messageEvent.data.toLowerCase() : '';
            switch (eventData) {
                case SURVEY_COMPLETED_GOBACKTODASHBOARD:
                    logUI("MBHWeb.UI.Covid19ScreenerSurvey.Completed.GoBackToDashboard", new Date(), getURLPath(), { "currentUser": currentUser ? currentUser : "" });
                    this.props.history.push('/');
                    break;
                case SURVEY_COMPLETED_SCHEDULEVIDEOVISIT:
                    logUI("MBHWeb.UI.Covid19ScreenerSurvey.Completed.ScheduleVideoVisit", new Date(), getURLPath(), { "currentUser": currentUser ? currentUser : "" });
                    this.props.history.push({ pathname: "/videovisitoptions", state: { isFromCovid19ScreenerSurvey: true } });
                    break;
                case SURVEY_COMPLETED_SCHEDULEEVISIT:
                    logUI("MBHWeb.UI.Covid19ScreenerSurvey.Completed.ScheduleEvisit", new Date(), getURLPath(), { "currentUser": currentUser ? currentUser : "" });
                    this.props.history.push({ pathname: "/evisitnow", state: { isFromCovid19ScreenerSurvey: true } });
                    break;
                case SURVEY_COMPLETED_FINDTESTINGLOCATION:
                    logUI("MBHWeb.UI.Covid19ScreenerSurvey.Completed.FindTestingLocation", new Date(), getURLPath(), { "currentUser": currentUser ? currentUser : "" });
                    const covid19TestLocation = serverData && serverData.covid19TestLocation ? serverData.covid19TestLocation : null;
                    if (typeof window !== 'undefined') window.open(covid19TestLocation, '_blank');
                    break;
                default:
                    if (typeof messageEvent.data === 'string' && messageEvent.data.indexOf('[iFrameSizer]') === -1) {
                        logUI("MBHWeb.UI.Covid19ScreenerSurvey." + (messageEvent.data ? messageEvent.data : "unknown"), new Date(), getURLPath());
                    }
            }
        }
    }

    render() {
        const { reloadKey, surveyBaseUrl, surveyIdForCovid19Screener, isProxyUser, currentUser, age, userName, surveyExternalEventIdForCovid19Screener } = this.props;
        const iframeResizerOptions = { checkOrigin: false, scrolling: true, heightCalculationMethod: 'bodyScroll', warningTimeout: 10000 };
        const iframeResizerStyle = { width: '100%' };
        const formID = "Covid19ScreenerSurvey";
        const userAge = currentUser && currentUser.ageYears ? currentUser.ageYears : age ? age : "";
        const firstName = currentUser && currentUser.displayName ? getFirstName(currentUser.displayName) : "";
        this.surveyUrl = surveyBaseUrl + "Covid/CovidTestTriage/" + surveyIdForCovid19Screener + "?UserId=" + (isProxyUser ? userName + "_" + firstName : userName)
            + "&ExternalEventId=" + (surveyExternalEventIdForCovid19Screener ? surveyExternalEventIdForCovid19Screener : "covidTest2021") + "&Age=" + userAge + "&Platform=WEB&firstname=" + firstName;

        return (
            <>
                {this.surveyUrl &&
                    <div className="mychartDataTile vaccine-eligibility-survey">
                        <React.Fragment >
                            <ReactIframeResizer ref="thisFrame" key={reloadKey} id={formID} title="Vaccine Eligibility Survey" onIframeLoaded={this.onSurveyLoaded} iframeResizerOptions={iframeResizerOptions} src={this.surveyUrl} style={iframeResizerStyle} />
                        </React.Fragment >
                    </div>
                }
            </>
        )
    }
}

const mapStateToProps = (state) => {
    const { surveyUrl, surveyIdForCovid19Screener, surveyExternalEventIdForCovid19Screener } = state.session.serverData;
    return {
        reloadKey: state.session.reloadKey,
        userName: state.domain.un,
        surveyBaseUrl: surveyUrl,
        surveyIdForCovid19Screener: surveyIdForCovid19Screener,
        surveyExternalEventIdForCovid19Screener: surveyExternalEventIdForCovid19Screener,
        isProxyUser: state.domain.ip,
        age: state.domain.age,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        proxyListLoading: state.memberships.proxyListLoading,
        serverData: state.session.serverData
    };
};

const mapDispatchToProps = () => ({
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Covid19ScreenerSurvey));